// extracted by mini-css-extract-plugin
export default {"Container":"JewelryPageProducts_Container__iX6HR","Title":"JewelryPageProducts_Title__gsV5V"};